import { theme } from "@product/scmp-sdk";
import type { FunctionComponent } from "react";
import type { Optional } from "utility-types";

import type { Props as AdSlotProps } from "~/components/advertisement/ad-slots/ad-slot";
import { type Props as OutstreamAdSlotProps } from "~/components/advertisement/ad-slots/outstream-ad-slot";
import { isNativeAdUnit, isOutstreamAdUnit } from "~/components/advertisement/ad-slots/types";
import { useRenderContext } from "~/components/content/content-schema-render";

import { Container, InlineNativeSlot, InlineOutstreamAdSlot, InlineSlot } from "./styles";

export type Props = Optional<AdSlotProps, "sizes"> | OutstreamAdSlotProps;

export const InlineAdSlot: FunctionComponent<Props> = props => {
  const { advertising } = useRenderContext();

  if (isOutstreamAdUnitProps(props)) {
    return <InlineOutstreamAdSlot {...advertising} {...props} />;
  }

  if (isNativeAdUnit(props.adUnit)) {
    return (
      <InlineNativeSlot
        {...advertising}
        autoRefreshOptions={{
          disableIntervalRefresh: true,
          disableScrollBackRefresh: true,
        }}
        sizes={["fluid"]}
        {...props}
      />
    );
  }

  return (
    <Container>
      <InlineSlot
        {...advertising}
        breakpoint={theme.breakpoints.down("desktop")}
        sizes={[[300, 250], [300, 600], [320, 480], "fluid"]}
        withBackground
        withLabel
        withSticky
        {...props}
      />
    </Container>
  );

  function isOutstreamAdUnitProps(props: Props): props is OutstreamAdSlotProps {
    return isOutstreamAdUnit(props.adUnit);
  }
};

InlineAdSlot.displayName = "InlineAdSlot";
